
import { View } from 'backbone';
import eventBus         from 'EventBus.js';

import nameTemplate from 'report/properties/main/chart-field.ejs';
import MainFormulaModal from 'common-views/MainFormulaModalView.js';
import listService  from 'ListService.js';
import util  from 'util/Util.js';

class MainChartFieldView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'click #valueFormula' :'updateValue',
            'change select' : 'updateSelectAttributes'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        
        if (propName === 'dataValue' || propName === 'dataValueSecondary') {
            let colid = '0';
            if(propName === 'dataValue'){
                this.updateColumnProperty(colid, 'aggregation', propVal);
                this.updateReportingMetaDataColumn(colid, 'aggregation', propVal);
            }else{                
                const dataType=$(ev.currentTarget).find(":selected").attr("datatype");
                this.updateColumnProperty(colid, 'fieldId', listService.getCleanedId(propVal));
                this.updateColumnProperty(colid, 'fieldDataType', dataType);
                this.updateReportingMetaDataColumnField(colid, listService.getCleanedId(propVal), dataType);
            }
        }

        this.model.set( propName, propVal, {silent:true} );
    }

     updateColumnProperty(rowid, propName, propVal) {
        const columns = this.model.get('Columns');
        columns.Column[rowid].Properties[propName] = propVal;
    }

    updateReportingMetaDataColumn(rowid, propName, propVal) {
        const md = listService.getReportingMetaData(this.model.get('id'));

        if (md.Columns) {
            _.forEach(md.Columns, (col) => {
                if (col.id.toString() === rowid.toString()) {
                    col[propName] = propVal;
                }
            });
        }
    }

    updateReportingMetaDataColumnField(rowid, dsFieldId, dataType, data ) {
        let md = listService.getReportingMetaData(this.model.get('id'));
        
        if(!md){
            listService.setReportingMetaData(this.model.get('dataSourceId'), this.model, true);
            md = listService.getReportingMetaData(this.model.get('id'));
        }

        if (md.Columns) {
            _.forEach(md.Columns, (col) => {
               if (col.id.toString() === rowid.toString()) {
                   col.aggregation = $('#dataValue option:selected').val();
                   if( data && data.arguments && util.isChart(this.model.get('factoryKey')) ){
                        col.Expression.id = data.id;
                        col.Expression.type = data.type;
                        col.Expression.Argument = data.arguments;
                    }else{
                        col.Expression.Argument = {type: 'reporting_datasourceField', value: dsFieldId, dataType: dataType};
                    }
               }
            });
        }
    }

    updateValue(ev){
        this.model.set('formulaType', ev.target.name, {silent:true});
        this.model.set('type', 'DataSource', {silent:true});
        this.model.set('title', 'Column Formula', {silent:true});
        var formulaModal = new MainFormulaModal({model:this.model});
        formulaModal.render().then((data)=>{
            if (ev.target.name === 'valueFormula'){
                this.updateColumnProperty('0', 'fieldId', 'Formula');
                this.updateColumnProperty('0', 'fieldDataType', 'NVARCHAR(400)');
                this.updateReportingMetaDataColumnField('0', 'Formula', 'NVARCHAR(400)', data); 
                this.updateColumnExpression('0');
                this.model.set( 'dataValueSecondary', 'Formula', {silent:true} );
            }
            this.model.set(ev.target.name,data, {silent:true});
            this.render();
        }).catch(e => {
            console.log(e);
        });
    }

    updateColumnExpression(rowid) {        
        const valueFormula = this.model.get('valueFormula');
        const columns = this.model.get('Columns');

        if (valueFormula && rowid === '0'){
            if (!columns.Column[rowid].EXPR){
                columns.Column[rowid].EXPR = {};
                columns.Column[rowid].EXPR.id = valueFormula.id;
                columns.Column[rowid].EXPR.type = valueFormula.type;
                columns.Column[rowid].EXPR.arguments = valueFormula.arguments;                   
            }else{
                columns.Column[rowid].EXPR.id = valueFormula.id;
                columns.Column[rowid].EXPR.type = valueFormula.type;
                columns.Column[rowid].EXPR.arguments = valueFormula.arguments;
            }
        }
      }

    setFieldsFromColumn() {
        const columns = this.model.get('Columns');
        const fieldValue = columns.Column[0].Properties.aggregation;
        this.model.set('dataValue',fieldValue, {silent:true});

        const fieldValueSec = columns.Column[0].Properties.fieldId;
        this.model.set('dataValueSecondary', fieldValueSec, {silent:true});
    }

    loadFieldsFromDatasource( dsId ) {
        const ds = listService.getDataSources(dsId);

        if (ds && ds.Fields && ds.Fields.Field) {

            const fieldValueEl = $('#dataValueSecondary');
            _.forEach(ds.Fields.Field, (field) => {
                if (util.isTrue(field.inUse)) {
                    let fname = '';

                    switch (field.id) {
                        case 'CreateDate':
                            fname = 'Meta - Last Submission Date';
                            break;
                        case 'E':
                            fname = 'Meta - Instance Number';
                            break;
                        case 'FormInstanceGUID':
                            fname = 'Meta - Instance ID';
                            break;
                        case 'FormInstanceId':
                            fname = 'Meta - Link';
                            break;
                        case 'MajorVersion':
                            fname = 'Meta - Version Major';
                            break;
                        case 'MinorVersion':
                            fname = 'Meta - Version Minor';
                            break;
                        case 'Name':
                            fname = 'Meta - Instance Name';
                            break;
                        case 'ParentGUID':
                            fname = 'Meta - Parent Instance ID';
                            break;
                        case 'StageName':
                            fname = 'Meta - Stage';
                            break;

                        default:
                            fname = field.name.replace('|',' - ');
                            break;
                    }
                    const elOpt2 = new Option((field.displayName.trim() || fname), listService.cleanId(field.id));
                    fieldValueEl[0].options[fieldValueEl[0].options.length] = elOpt2;
                    elOpt2.setAttribute("dataType", field.dataType);
                }
            });
            $('#dataValueSecondary').append('<optgroup label="──────────"></optgroup>');
            $('#dataValueSecondary').append('<option value="Formula">Formula</option>');

            $("#dataValue option[value='none']").remove();
            $('#dataValue').append('<option value="count">Count</option>');
            $('#dataValue').append('<option value="sum">Sum</option>');
            $('#dataValue').append('<option value="average">Average</option>');
            $('#dataValue').append('<option value="minimum">Minimum</option>');
            $('#dataValue').append('<option value="maximum">Maximum</option>');
            $('#dataValue').append('<option value="standardDeviation">Standard Deviation</option>');
            $('#dataValue').append('<option value="populationStandardDeviation">Population Standard Deviation</option>');
            $('#dataValue').append('<option value="variance">Variance</option>');
            $('#dataValue').append('<option value="populationVariance">Population Variance</option>');
        }
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.loadFieldsFromDatasource( listService.cleanId( this.model.get('dataSourceId') ));

        this.setFieldsFromColumn();

        let dataValueSecondary = this.model.get('dataValueSecondary');

        if(dataValueSecondary.toLowerCase() !== "formula"){
            dataValueSecondary = listService.cleanId(dataValueSecondary)
        }

        $("#dataValue option[value='" + this.model.get('dataValue') + "']").prop('selected', true);
        $("#dataValueSecondary option[value='" + dataValueSecondary + "']").prop('selected', true);
      

        this.delegateEvents();
        return this;
    }

}

export default MainChartFieldView;
